var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["modal-course-map", { mobile: _vm.isMobile(_vm.$mq) }] },
    [
      _vm.prerequisites.length
        ? _c("div", { staticClass: "prerequisites" }, [
            _c("h4", { staticClass: "title" }, [_vm._v("Prerequisites")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "courses" },
              _vm._l(_vm.prerequisites, function(prerequisite) {
                return _c("div", { staticClass: "course" }, [
                  _c(
                    "div",
                    { staticClass: "image" },
                    [
                      _c("BriocheBackgroundImage", {
                        attrs: {
                          src: prerequisite.intro_image_url,
                          width: _vm.isMobile ? 24 : 40
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "name" }, [
                    _vm._v(_vm._s(prerequisite.name))
                  ])
                ])
              }),
              0
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.nextSteps.length
        ? _c("div", { staticClass: "next-steps" }, [
            _c("h4", { staticClass: "title" }, [_vm._v("Next Steps")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "courses" },
              _vm._l(_vm.nextSteps, function(nextStep) {
                return _c("div", { staticClass: "course" }, [
                  _c(
                    "div",
                    { staticClass: "image" },
                    [
                      _c("BriocheBackgroundImage", {
                        attrs: {
                          src: nextStep.intro_image_url,
                          width: _vm.isMobile ? 24 : 40
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "name" }, [
                    _vm._v(_vm._s(nextStep.name))
                  ])
                ])
              }),
              0
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }